import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { login, resetPasswordRequest, resetPassword, userRegistration } from '../../api/authorization.api'
import { saveLocalToken } from '../../services/authorizationService';
import { AuthData } from './AuthWrapper';
import { showSuccess, showError } from '../../services/toastServices';
import { getIsAlive } from '../../api/utils.api';


const LoginPage = (props) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate()
  const {loginRefresh} = AuthData();
  

  const handleLogin = handleSubmit(async data => {
    await getIsAlive()
    await login(data, loginSuccess, loginError)
    
})

  const loginSuccess = ((response)=>{
    showSuccess('Email y clave correctos')
    saveLocalToken(response.data.token)
    
    loginRefresh({token: response.data.token, isAuthenticated: response.data.token !== ""})
    navigate('/')
  })

  const loginError = ((error)=>{
    showError('Error de conexión')
    if (!error.response) {
      // network error
      this.errorStatus = 'Error: Network Error';
    } else {
        this.errorStatus = error.response.data.message;
    }
  })

  return (
    <div className="mainContainer">
      <div className='mx-auto grid grid-cols-4 gap-x-2'>
        <div className='col-start-2 col-span-2'>
          <div className="flex justify-center py-3">
            <h1 className='font-bold'>Login Page!</h1>
          </div>
        </div>
        <form action="" className='col-start-2 col-span-2'>
          <input
              type="text"
              placeholder="Email"
              {...register("email", { required: true })}
              className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
          />
          {errors.email && <span>Campo requerido</span>}

          <input
              type="password"
              placeholder="Password"
              {...register("password", { required: true })}
              className=' bg-blue-100 p-3 rounded-lg w-full mb-3'
          />
          {errors.password && <span>Campo requerido</span>}

        </form>
        <button className=' bg-blue-400 p-3 rounded-lg block w-full col-start-2 col-span-2 hover:bg-blue-500' onClick={handleLogin}>Login</button>            
      </div>
    </div>
  )
}

export default LoginPage